export enum TypesBidEnum {
    STANDARD = 'STANDARD',
    FREE = 'FREE',
    BID = 'BID',
    WAITING_LIST = 'WAITING_LIST'
}

export enum TierTypeFormattedEnum {
    CLASICA = 'Clásica',
    PLATA = 'Plata',
    ORO = 'Oro',
    PLATINO = 'Platino',
    PLATINO_PRIME = 'Platino Prime',
    INFINITA = 'Infinita',
    INFINITA_PRIME = 'Infinita Prime'
}

export enum TierTypeEnum {
    CLASICA = 'CLASICA',
    PLATA = 'PLATA',
    ORO = 'ORO',
    PLATINO = 'PLATINO',
    PLATINO_PRIME = 'PLATINO PRIME',
    INFINITA = 'INFINITA',
    INFINITA_PRIME = 'INFINITA PRIME'
}
